module.exports = __webpack_public_path__ + "static/media/SocksStill.e827da8c.jpg";